import * as Yup from "yup"

const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

const Validation = (content) => {
    // console.log(content)
    return ({
        2: Yup.object().shape({
            inLAcounty: Yup.string().matches(
                1, "Your address is not in Los Angeles County. Please correct if you mistyped."
            ).required("Please enter an address"),
        }),
        3: Yup.object().shape({
            submitted_requests: Yup.array().min(1, content[3].warning).required(),
        }),
        4: Yup.object().shape({
            client_an_immigrant: Yup.string().required(content[4].warning),
        }),
        5: Yup.object().shape({
            client_income_covid19: Yup.string().required(content[5].warning),
        }),
        6: Yup.object().shape({
            phone: Yup.string()
                .matches(phoneRegExp, "Phone number is not valid")
                .required("A phone number is needed to reach you"),
            first_name: Yup.string().required(content[6].warning),
            last_name: Yup.string().required(content[6].warning),
            email: Yup.string().email("Please retype your email or leave blank"),
            preferred_language: Yup.array().min(1, content[6].warning).required(),
            langugage_spoken: Yup.array().min(1, content[6].warning).required(),
            accommodations: Yup.string().required(content[6].warning),
        }),
        7: Yup.object().shape({
            referredbyprovider: Yup.string().required(content[5].warning),
        }),
    })
}

export default Validation